<template>
  <div class="main-container d-content">
    <div class="row fbp-summary-box">
      <p class="fbp-declaration-text">FBP Claims</p>
      <div class="row amountDiv">
        <div
          class="col-2 amountColum"
          v-for="fbpComponent in fbpComponentList"
          :key="fbpComponent.id"
        >
          <div class="amountHeading">{{ fbpComponent.SalaryComponentLegalEntity.name }}</div>
          <div class="forButton">
            <div class="fbpAmount">{{ formate.format(fbpComponent.totalAmtApproved)}}</div>
            <button
              class="saveButton"
              @click="componentNameOnButton(fbpComponent)"
            >
              Add New
            </button>
          </div>
        </div>
      </div>
    </div>
    <pop-up-window-lg
      v-if="showPopupExemptionUnderSectionDeduction"
      @back="
        showPopupExemptionUnderSectionDeduction =
          !showPopupExemptionUnderSectionDeduction
      "
      :header="componentHeader"
    >
      <template v-slot:content>
        <add-new-claims :fbpComponentName="componentHeader" :recordData="recordData" @backFromClaims="backFromClaims"> </add-new-claims>
      </template>
    </pop-up-window-lg>
       <pop-up-window-lg
      v-if="transactionPopUp"
      @back="
        transactionPopUp =
          !transactionPopUp
      "
      :header="transactionViewHeader"
    >
      <template v-slot:content>
        <fbp-Transactions :componentName="transactionViewHeader"> </fbp-Transactions>
      </template>
    </pop-up-window-lg>

    <div class="tableList">
      <data-table
        class="tableClass"
        :columns="fbpColums"
        :tableData="fbpData"
        :showinrow="true"
        @editStart="false"
        :showedit="false"
        :showdelete="false"
        :showhistory="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'name'">
            {{ slotprops.value.record.SalaryComponentLegalEntity.name }}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'eligibleAmount'">
            {{ formateLess.format(slotprops.value.record.eligibleAmount) }}
          </p>
           <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'declaredAmount'">
            {{ formateLess.format(slotprops.value.record.declaredAmount) }}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'totalAmtClaimed'">
            {{ formateLess.format(slotprops.value.record.totalAmtClaimed )}}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'totalAmtApproved'">
            {{ formateLess.format(slotprops.value.record.totalAmtApproved) }}
          </p>
          <!-- <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'paid'">
            {{ formateLess.format(slotprops.value.record.paid)}}
          </p> -->
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'balance'">
            {{ formateLess.format(slotprops.value.record.balance) }}
          </p>
          <p style="text-align:right;" class="rightAlign" v-if="slotprops.value.column.key == 'unpaid'">
            {{ formateLess.format(slotprops.value.record.unpaid) }}
          </p>
          <p  v-if="slotprops.value.column.key == 'history'">
          <img class="arrow-icon-it" title="History" @click="transactionViewFunction( slotprops.value.record)" src="@/assets/historyBlue.svg"/>
          </p>
          
        </template>
        
      </data-table>
    </div>
    <footer>
      <bottom-action-container>
        <template slot="end">
          <btn-grp class="form-button">
            <btn
              :disabled="showErrorMsg"
              text="cancel"
              type="secondary"
              @click="goBack"
            />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import addNewClaims from "./addNewClaims.vue";
import fbpTransactions from "./fbpTransactions.vue"
import { mapGetters,mapActions,mapState } from "vuex";
export default {
  components: {
    addNewClaims,
    fbpTransactions,
  },
  name: "fbpClaimsEss",
  data() {
    return {
      totalAllocatedAmount: "₹8,31,323.00",
      fbpAllocationAmount: "₹92,321.00",
      fbpUnallocatedAmount: "₹32,232.00",
      showPopupExemptionUnderSectionDeduction: false,
      componentHeader: "",
      transactionPopUp:false,
      transactionViewHeader:"",
      formate:"",
      formateLess:"",
      fbpComponentList: [],
      recordData:{},
      fbpColums: [
        {
          label: "Reimbursements",
          key: "name",
        },
        {
          label: "YTD Eligibility(₹)",
          key: "eligibleAmount",
          style:'text-align:right',
        },
        {
          label: "YTD Declared(₹)",
          key: "declaredAmount",
          style:'text-align:right',
        },
        {
          label: "YTD Claimed(₹)",
          key: "totalAmtClaimed",
          style: 'text-align:right',
        },
        {
          label: "Approved(₹)",
          key: "totalAmtApproved",
          style: 'text-align:right',
        },
        // {
        //   label: "Paid(₹)",
        //   key: "paid",
        //   style: 'text-align:right',
        // },
        {
          label: "Balance(₹)",
          key: "balance",
          style: 'text-align:right',
        },
        // {
        //   label: "Unpaid(₹)",
        //   key: "unpaid",
        //   style: 'text-align:right',
        // },
        {
          label: "History",
          key: "history",
        },
      ],
      fbpData: [],
    };
  },
  mounted(){
   this.fetchAllData()
  },
  computed:{
    le_id() {
      return localStorage.getItem("le_id")
    },
    empId() {
      return localStorage.getItem("empId")
    },
  },
  methods: {
    ...mapActions({
      act_fetchAll: "dashboard/humanResource/fbpClaims/fetchAll",
    }),
    componentNameOnButton(record) {
      this.showPopupExemptionUnderSectionDeduction = true;
      this.componentHeader =record.SalaryComponentLegalEntity.name;
      this.recordData = record
    },
    transactionViewFunction(record)
    { 
      this.transactionPopUp=true;
      this.transactionViewHeader=record.SalaryComponentLegalEntity.name
    },
    goBack() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      });
      this.showSuccessMsg = false;
    },

    backFromClaims(){
      this.showPopupExemptionUnderSectionDeduction = false;
      this.fetchAllData();
    },

    async fetchAllData()
    {
      try{
       let res = await this.act_fetchAll({
        le_id: this.le_id,
          emp_id: this.empId,
       })
        this.fbpData = res.data.payload
        this.fbpComponentList = res.data.payload
        this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
      }catch(error)
      {
        this.toast = true;
        this.errmsg = error;
      }

    }
  },
};
</script>
<style lang="scss" scoped>
.amountColum {
  background: white;
  padding: 16px;
  margin: 5px;
  flex: 0 0 22%;
  max-width: 22%;
  border-radius: 8px;
}
.forButton {
  display: flex;
  justify-content: space-between;
}
.tableList {
  margin-top: 20px;
  margin-left: 20px;
}
.fbp-summary-box {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
  margin-left: 15px;
}
.fbp-declaration-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: "Montserrat";
}
.amountHeading {
  margin-bottom: 8px;
  font-size: medium;
  font-weight: 500;
  text-transform: capitalize;
}
.fbpAmount {
  font-weight: 600;
  color: #5a5a5a;
  font-family: "Montserrat";
}
.custom {
  width: 180px;
}
.saveButton {
  padding: 7px 20px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  background-color: #5d409f;
  border-radius: 4px;
  margin-left: 0px;
  margin-top: -4px;
}
.arrow-icon-it {
  cursor: pointer;
  border-radius: 50%;
  height: 20px;
  position: relative;
  top: calc(50% - 10px);
  margin-left: 2rem;
}
.rightAlign{
  padding-left:"0";
}
.tableClass{
  text-transform: capitalize;
}
</style>
